import http from "../../http-common";

const getCountry = (data) => http.post("/Region/FilterCountry", data);

const createCountry = (data) => http.post("/Region/InsertCountry", data);

const updateCountry = (data) => http.put("/Region/UpdateCountry", data);

const getState = (data) => http.post("/Region/FilterState", data);

const createState = (data) => http.post("/Region/InsertState", data);

const updateState = (data) => http.put("/Region/UpdateState", data);

const getCity = (data) => http.post("/Region/FilterCity", data);

const createCity = (data) => http.post("/Region/InsertCity", data);

const updateCity = (data) => http.put("/Region/UpdateCity", data);

export default {
    getCountry,
    createCountry,
    updateCountry,
    getState,
    createState,
    updateState,
    getCity,
    createCity,
    updateCity,
};
